/**
 * The registry's segmented pill (docs/ux/registry.md "Read-only lists"):
 * Doctors, Referrers, Clinics, Templates and Practice are routes, so the
 * pill navigates rather than holding state; the doctor list keeps its own
 * design.
 */

import { useNavigate } from 'react-router';
import { QueueTabs } from '@/components/shell/QueueTabs';

export type RegistryList = 'doctors' | 'referrers' | 'clinics' | 'templates' | 'practice';

const HREF: Record<RegistryList, string> = { doctors: '/registry', referrers: '/registry/referrers', clinics: '/registry/clinics', templates: '/registry/templates', practice: '/registry/practice' };
const TABS = [{ value: 'doctors', label: 'Doctors' }, { value: 'referrers', label: 'Referrers' }, { value: 'clinics', label: 'Clinics' }, { value: 'templates', label: 'Templates' }, { value: 'practice', label: 'Practice' }];

export function RegistryPill({ current }: { current: RegistryList }) {
  const navigate = useNavigate();
  return <QueueTabs tabs={TABS} value={current} onChange={(v) => { if (v !== current) void navigate(HREF[v as RegistryList]); }} label="Registry lists" />;
}
